/* AUTO-GENERATED by scratchpad/gen-doclinks.js from the converted PDFs.
 * Do not edit by hand — regenerate if the document set changes.
 * Served from fe-sml/public/manufacturing-docs/ (relative URL -> works on any host/IP). */
import { showPdf } from "./pdfViewer";

export const docUrl = (name) =>
  name ? `${process.env.PUBLIC_URL || ""}/manufacturing-docs/${encodeURIComponent(name)}` : null;

// Displays the PDF inline in an in-app viewer (Dialog + iframe) instead of a new tab.
export const openDoc = (name) => showPdf(docUrl(name), name);

const IN_PROCESS_DOCS = {
  "2388-OXB-A-1": {
    "IPS-2388-006": {
      "METABOLITE": "2388-OXB-A-1_AR-IP-2388-113_IPS-2388-006.pdf",
      "VCC": "2388-OXB-A-1_IPS-2388-006_VCC_AR-IP-2388-111.pdf",
      "VIABILITY": "2388-OXB-A-1_IPS-2388-006_VIABILITY_AR-IP-2388-112.pdf"
    },
    "IPS-2388-007": {
      "METABOLITE": "2388-OXB-A-1_AR-IP-2388-121_IPS-2388-007.pdf",
      "VCC": "2388-OXB-A-1_IPS-2388-007_VCC_AR-IP-2388-119.pdf",
      "VIABILITY": "2388-OXB-A-1_IPS-2388-007_VIABILITY_AR-IP-2388-119.pdf"
    },
    "IPS-2388-008": {
      "METABOLITE": "2388-OXB-A-1_AR-IP-2388-127_IPS-2388-008.pdf",
      "VCC": "2388-OXB-A-1_IPS-2388-008_VCC_AR-IP-2388-120.pdf",
      "VIABILITY": "2388-OXB-A-1_IPS-2388-008_VIABILITY_AR-IP-2388-120.pdf"
    },
    "IPS-2388-009": {
      "METABOLITE": "2388-OXB-A-1_AR-IP-2388-135_IPS-2388-009.pdf",
      "VCC": "2388-OXB-A-1_IPS-2388-009_VCC_AR-IP-2388-133.pdf",
      "VIABILITY": "2388-OXB-A-1_IPS-2388-009_VIABILITY_AR-IP-2388-134.pdf"
    },
    "IPS-2388-010": {
      "METABOLITE": "2388-OXB-A-1_AR-IP-2388-143_IPS-2388-010.pdf",
      "VCC": "2388-OXB-A-1_IPS-2388-010_VCC_AR-IP-2388-141.pdf",
      "VIABILITY": "2388-OXB-A-1_IPS-2388-010_VIABILITY_AR-IP-2388-142.pdf"
    },
    "IPS-2388-011": {
      "METABOLITE": "2388-OXB-A-1_AR-IP-2388-150_IPS-2388-011.pdf",
      "VCC": "2388-OXB-A-1_IPS-2388-011_VCC_AR-IP-2388-149.pdf"
    },
    "IPS-2388-012": {
      "METABOLITE": "2388-OXB-A-1_AR-IP-2388-159_IPS-2388-012.pdf",
      "VCC": "2388-OXB-A-1_IPS-2388-012_VCC_AR-IP-2388-156.pdf",
      "VIABILITY": "2388-OXB-A-1_IPS-2388-012_VIABILITY_AR-IP-2388-157.pdf"
    },
    "IPS-2388-013": {
      "METABOLITE": "2388-OXB-A-1_AR-IP-2388-168_IPS-2388-013.pdf",
      "VCC": "2388-OXB-A-1_IPS-2388-013_VCC_AR-IP-2388-165.pdf",
      "VIABILITY": "2388-OXB-A-1_IPS-2388-013_VIABILITY_AR-IP-2388-166.pdf"
    },
    "IPS-2388-014": {
      "METABOLITE": "2388-OXB-A-1_AR-IP-2388-175_IPS-2388-014.pdf",
      "VCC": "2388-OXB-A-1_IPS-2388-014_VCC_AR-IP-2388-174.pdf",
      "VIABILITY": "2388-OXB-A-1_IPS-2388-014_VIABILITY_AR-IP-2388-174.pdf"
    },
    "IPS-2388-015": {
      "METABOLITE": "2388-OXB-A-1_AR-IP-2388-183_IPS-2388-015.pdf",
      "VCC": "2388-OXB-A-1_IPS-2388-015_VCC_AR-IP-2388-181.pdf"
    },
    "IPS-2388-016": {
      "METABOLITE": "2388-OXB-A-1_AR-IP-2388-191_IPS-2388-016.pdf",
      "VCC": "2388-OXB-A-1_IPS-2388-016_VCC_AR-IP-2388-189.pdf",
      "VIABILITY": "2388-OXB-A-1_IPS-2388-016_VIABILITY_AR-IP-2388-190.pdf"
    },
    "IPS-2388-001": {
      "VCC": "2388-OXB-A-1_IPS-2388-001_VCC_AR-IP-2388-101.pdf",
      "VIABILITY": "2388-OXB-A-1_IPS-2388-001_VIABILITY_AR-IP-2388-102.pdf"
    },
    "IPS-2388-002": {
      "VCC": "2388-OXB-A-1_IPS-2388-002_VCC_AR-IP-2388-103.pdf",
      "VIABILITY": "2388-OXB-A-1_IPS-2388-002_VIABILITY_AR-IP-2388-104.pdf"
    },
    "IPS-2388-003": {
      "VCC": "2388-OXB-A-1_IPS-2388-003_VCC_AR-IP-2388-105.pdf",
      "VIABILITY": "2388-OXB-A-1_IPS-2388-003_VIABILITY_AR-IP-2388-106.pdf"
    },
    "IPS-2388-004": {
      "VCC": "2388-OXB-A-1_IPS-2388-004_VCC_AR-IP-2388-107.pdf",
      "VIABILITY": "2388-OXB-A-1_IPS-2388-004_VIABILITY_AR-IP-2388-108.pdf"
    },
    "IPS-2388-005": {
      "VCC": "2388-OXB-A-1_IPS-2388-005_VCC_AR-IP-2388-109.pdf",
      "VIABILITY": "2388-OXB-A-1_IPS-2388-005_VIABILITY_AR-IP-2388-110.pdf"
    },
    "IPS-2388-023": {
      "VCC": "2388-OXB-A-1_IPS-2388-023_VCC_AR-IP-2388-204.pdf",
      "VIABILITY": "2388-OXB-A-1_IPS-2388-023_VIABILITY_AR-IP-2388-205.pdf"
    }
  },
  "2785-OXB-B-1": {
    "IPS-2785-006": {
      "METABOLITE": "2785-OXB-B-1_AR-IP-2025-113_IPS-2785-006.pdf",
      "VCC": "2785-OXB-B-1_IPS-2785-006_VCC_AR-IP-2025-111.pdf",
      "VIABILITY": "2785-OXB-B-1_IPS-2785-006_VIABILITY_AR-IP-2025-112.pdf"
    },
    "IPS-2785-007": {
      "METABOLITE": "2785-OXB-B-1_AR-IP-2025-121_IPS-2785-007.pdf",
      "VCC": "2785-OXB-B-1_IPS-2785-007_VCC_AR-IP-2025-119.pdf",
      "VIABILITY": "2785-OXB-B-1_IPS-2785-007_VIABILITY_AR-IP-2025-119.pdf"
    },
    "IPS-2785-008": {
      "METABOLITE": "2785-OXB-B-1_AR-IP-2025-127_IPS-2785-008.pdf",
      "VCC": "2785-OXB-B-1_IPS-2785-008_VCC_AR-IP-2025-120.pdf",
      "VIABILITY": "2785-OXB-B-1_IPS-2785-008_VIABILITY_AR-IP-2025-120.pdf"
    },
    "IPS-2785-009": {
      "METABOLITE": "2785-OXB-B-1_AR-IP-2025-135_IPS-2785-009.pdf",
      "VCC": "2785-OXB-B-1_IPS-2785-009_VCC_AR-IP-2025-133.pdf",
      "VIABILITY": "2785-OXB-B-1_IPS-2785-009_VIABILITY_AR-IP-2025-134.pdf"
    },
    "IPS-2785-010": {
      "METABOLITE": "2785-OXB-B-1_AR-IP-2025-143_IPS-2785-010.pdf",
      "VCC": "2785-OXB-B-1_IPS-2785-010_VCC_AR-IP-2025-141.pdf",
      "VIABILITY": "2785-OXB-B-1_IPS-2785-010_VIABILITY_AR-IP-2025-142.pdf"
    },
    "IPS-2785-011": {
      "METABOLITE": "2785-OXB-B-1_AR-IP-2025-150_IPS-2785-011.pdf",
      "VCC": "2785-OXB-B-1_IPS-2785-011_VCC_AR-IP-2025-149.pdf"
    },
    "IPS-2785-012": {
      "METABOLITE": "2785-OXB-B-1_AR-IP-2025-159_IPS-2785-012.pdf",
      "VCC": "2785-OXB-B-1_IPS-2785-012_VCC_AR-IP-2025-156.pdf",
      "VIABILITY": "2785-OXB-B-1_IPS-2785-012_VIABILITY_AR-IP-2025-157.pdf"
    },
    "IPS-2785-013": {
      "METABOLITE": "2785-OXB-B-1_AR-IP-2025-168_IPS-2785-013.pdf",
      "VCC": "2785-OXB-B-1_IPS-2785-013_VCC_AR-IP-2025-165.pdf",
      "VIABILITY": "2785-OXB-B-1_IPS-2785-013_VIABILITY_AR-IP-2025-166.pdf"
    },
    "IPS-2785-014": {
      "METABOLITE": "2785-OXB-B-1_AR-IP-2025-175_IPS-2785-014.pdf",
      "VCC": "2785-OXB-B-1_IPS-2785-014_VCC_AR-IP-2025-174.pdf",
      "VIABILITY": "2785-OXB-B-1_IPS-2785-014_VIABILITY_AR-IP-2025-174.pdf"
    },
    "IPS-2785-015": {
      "METABOLITE": "2785-OXB-B-1_AR-IP-2025-183_IPS-2785-015.pdf",
      "VCC": "2785-OXB-B-1_IPS-2785-015_VCC_AR-IP-2025-181.pdf"
    },
    "IPS-2785-016": {
      "METABOLITE": "2785-OXB-B-1_AR-IP-2025-191_IPS-2785-016.pdf",
      "VCC": "2785-OXB-B-1_IPS-2785-016_VCC_AR-IP-2025-189.pdf",
      "VIABILITY": "2785-OXB-B-1_IPS-2785-016_VIABILITY_AR-IP-2025-190.pdf"
    },
    "IPS-2785-001": {
      "VCC": "2785-OXB-B-1_IPS-2785-001_VCC_AR-IP-2025-101.pdf",
      "VIABILITY": "2785-OXB-B-1_IPS-2785-001_VIABILITY_AR-IP-2025-102.pdf"
    },
    "IPS-2785-002": {
      "VCC": "2785-OXB-B-1_IPS-2785-002_VCC_AR-IP-2025-103.pdf",
      "VIABILITY": "2785-OXB-B-1_IPS-2785-002_VIABILITY_AR-IP-2025-104.pdf"
    },
    "IPS-2785-003": {
      "VCC": "2785-OXB-B-1_IPS-2785-003_VCC_AR-IP-2025-105.pdf",
      "VIABILITY": "2785-OXB-B-1_IPS-2785-003_VIABILITY_AR-IP-2025-106.pdf"
    },
    "IPS-2785-004": {
      "VCC": "2785-OXB-B-1_IPS-2785-004_VCC_AR-IP-2025-107.pdf",
      "VIABILITY": "2785-OXB-B-1_IPS-2785-004_VIABILITY_AR-IP-2025-108.pdf"
    },
    "IPS-2785-005": {
      "VCC": "2785-OXB-B-1_IPS-2785-005_VCC_AR-IP-2025-109.pdf",
      "VIABILITY": "2785-OXB-B-1_IPS-2785-005_VIABILITY_AR-IP-2025-110.pdf"
    },
    "IPS-2785-023": {
      "VCC": "2785-OXB-B-1_IPS-2785-023_VCC_AR-IP-2025-204.pdf",
      "VIABILITY": "2785-OXB-B-1_IPS-2785-023_VIABILITY_AR-IP-2025-205.pdf"
    }
  }
};
const RELEASE_DOCS = {
  "2785-OXB-B-1": {
    "APP": "Test_Report_AR-APP-2025-202_Appearance.pdf",
    "IDT": "Test_Report_AR-IDT-2025-201_Transgene-Identity.pdf",
    "IDV": "Test_Report_AR-IDV-2025-201_VSVG-Identity.pdf",
    "P24": "Test_Report_AR-P24-2025-203_p24-Physical-Titre.pdf",
    "TIT": "Test_Report_AR-TIT-2025-203_Infectious-Titre.pdf"
  },
  "2388-OXB-A-1": {
    "APP": "Test_Report_AR-APP-2388-102_Appearance.pdf",
    "IDT": "Test_Report_AR-IDT-2388-101_Transgene-Identity.pdf",
    "IDV": "Test_Report_AR-IDV-2388-101_VSVG-Identity.pdf",
    "P24": "Test_Report_AR-P24-2388-103_p24-Physical-Titre.pdf",
    "TIT": "Test_Report_AR-TIT-2388-103_Infectious-Titre.pdf"
  }
};
const AR_DOCS = {
  "TZB2401-DS": {
    "AR-A280-2026-042": "TZB2401-DS_AR-A280-2026-042_Protein-concentration-A280.pdf",
    "AR-ADCC-2026-033": "TZB2401-DS_AR-ADCC-2026-033_ADCC-bioassay.pdf",
    "AR-AFU-2026-018": "TZB2401-DS_AR-AFU-2026-018_Afucosylated-Glycans-by-N-Glycan-Map-HILIC-UPLC.pdf",
    "AR-AGG-2026-010": "TZB2401-DS_AR-AGG-2026-010_Aggregates-by-SEC-HPLC.pdf",
    "AR-APP-2026-005": "TZB2401-DS_AR-APP-2026-005_Appearance.pdf",
    "AR-BAG-2026-050": "TZB2401-DS_AR-BAG-2026-050_Bag-integrity-visual-pressure-decay.pdf",
    "AR-BIO-2026-019": "TZB2401-DS_AR-BIO-2026-019_Bioburden-pre-harvest.pdf",
    "AR-BIO-2026-030": "TZB2401-DS_AR-BIO-2026-030_Bioburden.pdf",
    "AR-BIO-2026-047": "TZB2401-DS_AR-BIO-2026-047_Bioburden-pre-sterile-filtration.pdf",
    "AR-BWT-2026-049": "TZB2401-DS_AR-BWT-2026-049_DS-bag-fill-weight.pdf",
    "AR-CER-2026-013": "TZB2401-DS_AR-CER-2026-013_Reduced-HC-LC-Purity-by-CE-SDS.pdf",
    "AR-CONC-2026-007": "TZB2401-DS_AR-CONC-2026-007_Protein-concentration-A280.pdf",
    "AR-END-2026-031": "TZB2401-DS_AR-END-2026-031_Endotoxin-LAL.pdf",
    "AR-END-2026-036": "TZB2401-DS_AR-END-2026-036_Endotoxin-LAL.pdf",
    "AR-FILT-2026-038": "TZB2401-DS_AR-FILT-2026-038_Post-use-filter-integrity-Planova.pdf",
    "AR-FILT-2026-048": "TZB2401-DS_AR-FILT-2026-048_Sterile-filter-integrity-bubble-point.pdf",
    "AR-FZ-2026-051": "TZB2401-DS_AR-FZ-2026-051_Controlled-rate-freeze-cycle-conformance.pdf",
    "AR-HCD-2026-020": "TZB2401-DS_AR-HCD-2026-020_Residual-host-cell-DNA-qPCR.pdf",
    "AR-HCD-2026-028": "TZB2401-DS_AR-HCD-2026-028_Residual-host-cell-DNA-qPCR.pdf",
    "AR-HCP-2026-019": "TZB2401-DS_AR-HCP-2026-019_Host-cell-protein-HCP-ELISA.pdf",
    "AR-HCP-2026-027": "TZB2401-DS_AR-HCP-2026-027_Host-cell-protein-HCP-ELISA.pdf",
    "AR-ICIEF-2026-034": "TZB2401-DS_AR-ICIEF-2026-034_Charge-Variants-by-iCIEF.pdf",
    "AR-ICM-2026-014": "TZB2401-DS_AR-ICM-2026-014_Charge-Variants-by-iCIEF.pdf",
    "AR-IDP-2026-001": "TZB2401-DS_AR-IDP-2026-001_Identity-by-Tryptic-Peptide-Map-LC-MS.pdf",
    "AR-MYC-2026-001": "TZB2401-DS_AR-MYC-2026-001_Mycoplasma-NAT.pdf",
    "AR-OSM-2026-025": "TZB2401-DS_AR-OSM-2026-025_Osmolality.pdf",
    "AR-PAL-2026-021": "TZB2401-DS_AR-PAL-2026-021_Protein-A-leachate-ELISA.pdf",
    "AR-PAL-2026-029": "TZB2401-DS_AR-PAL-2026-029_Protein-A-leachate.pdf",
    "AR-PH-2026-024": "TZB2401-DS_AR-PH-2026-024_pH.pdf",
    "AR-PH-2026-030": "TZB2401-DS_AR-PH-2026-030_pH-at-low-pH-viral-inactivation.pdf",
    "AR-PH-2026-043": "TZB2401-DS_AR-PH-2026-043_pH-bulk-DS.pdf",
    "AR-POT-2026-032": "TZB2401-DS_AR-POT-2026-032_Potency-HER2-binding.pdf",
    "AR-PS20-2026-023": "TZB2401-DS_AR-PS20-2026-023_Polysorbate-20-content.pdf",
    "AR-SEC-2026-033": "TZB2401-DS_AR-SEC-2026-033_Aggregates-by-SEC-HPLC.pdf",
    "AR-TIT-2026-021": "TZB2401-DS_AR-TIT-2026-021_Harvest-Titer-by-Protein-A-HPLC-Assay.pdf",
    "AR-TRE-2026-022": "TZB2401-DS_AR-TRE-2026-022_Trehalose-content.pdf",
    "AR-VIT-2026-031": "TZB2401-DS_AR-VIT-2026-031_Hold-time-at-low-pH.pdf"
  }
};              // batch -> { analyticalReportNumber: pdf } (Herceptin-style)
const DEVIATION_DOCS = {
  "2388-OXB-A-1": {
    "final": "Deviation_Report_DEV-5842_2388-OXB-A-1.pdf",
    "assessment": "Investigation_Report_IR-OXB-2388-001_2388-OXB-A-1.pdf"
  },
  "2785-OXB-B-1": {
    "final": "Deviation_Report_DEV-5970_2785-OXB-B-1.pdf",
    "assessment": "Investigation_Report_IR-OXB-2785-001_2785-OXB-B-1.pdf"
  },
  "QE-2026-011": {
    "assessment": "QE-2026-011_Deviation_Assessment_Report_TZB2401-DS.pdf",
    "final": "QE-2026-011_Final_Deviation_Report_TZB2401-DS.pdf"
  }
};
const CC_DOCS = {
  "SCC-2025-092": "Planned_Change_Request_PC-OXB-2388-092_2388-OXB-A-1.pdf",
  "SCC-2025-121": "Planned_Change_Request_PC-OXD-2785-121_2785-OXB-B-1.pdf",
  "SCC-2026-101": "SCC-2026-101_Planned_Change_Control_Report_TZB2401-DS.pdf"
};
const BATCH_DOCS = {
  "2388-OXB-A-1": {
    "bpr": "Batch_Production_Record_2388-OXB-A-1.pdf",
    "coa": "CoA_2388-OXB-A-1.pdf"
  },
  "2785-OXB-B-1": {
    "bpr": "Batch_Production_Record_2785-OXB-B-1.pdf",
    "coa": "CoA_2785-OXB-B-1.pdf"
  },
  "TZB2401-DS": {
    "bpr": "Batch_Production_Record_TZB2401-DS.pdf",
    "coa": "CoA_TZB2401-DS.pdf"
  }
};

// ---- resolvers (return a served pdf filename, or null when no document exists) ----
const ipCategory = (row) => {
  const d = `${row.sampleDescription || ""} ${row.methodId || ""}`;
  if (/Viable cell concentration|\bVCC\b/i.test(d)) return "VCC";
  if (/Viability/i.test(d)) return "VIABILITY";
  if (/Glucose|Lactate|Na\+|K\+|Ca\+\+|Osmo|Metabolite|Offline pH|\bpH\b/i.test(d)) return "METABOLITE";
  return null;
};
// Herceptin-style rows carry an explicit analyticalReportNumber -> resolve directly.
const arDoc = (batchNumber, row) =>
  (row && row.analyticalReportNumber && AR_DOCS[batchNumber] && AR_DOCS[batchNumber][row.analyticalReportNumber]) || null;
export const inProcessDoc = (batchNumber, row) => {
  const ar = arDoc(batchNumber, row);
  if (ar) return ar;
  const cat = ipCategory(row);
  return (cat && IN_PROCESS_DOCS[batchNumber] && IN_PROCESS_DOCS[batchNumber][row.sampleId]
    && IN_PROCESS_DOCS[batchNumber][row.sampleId][cat]) || null;
};
export const releaseDoc = (batchNumber, row) => {
  const ar = arDoc(batchNumber, row);
  if (ar) return ar;
  // VV sampleId formats differ per batch ("DS-2388-IDT-01" / "DS-IDT-001") -> match test code segment.
  const docs = RELEASE_DOCS[batchNumber] || {};
  const sid = (row.sampleId || "").toUpperCase();
  for (const code of Object.keys(docs)) {
    if (new RegExp("(^|[-_])" + code + "([-_]|$)").test(sid)) return docs[code];
  }
  return null;
};
// VV keys DEVIATION_DOCS by batch (one deviation/batch); Herceptin keys by deviationNumber (multiple).
export const deviationDocs = (batchNumber, row) => {
  if (row && row.deviationNumber && DEVIATION_DOCS[row.deviationNumber]) return DEVIATION_DOCS[row.deviationNumber];
  return DEVIATION_DOCS[batchNumber] || {};
};
export const ccDoc = (sponsorCCNumber) => CC_DOCS[sponsorCCNumber] || null;
export const coaDoc = (batchNumber) => (BATCH_DOCS[batchNumber] || {}).coa || null;
export const bprDoc = (batchNumber) => (BATCH_DOCS[batchNumber] || {}).bpr || null;
